import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Brain, Calendar, ShieldCheck, HeartPulse, Users, AlertTriangle } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    icon: <Brain className="w-8 h-8 text-green-400" data-id="element-320" />,
    title: 'TOMO 1 — La Mente de Tu Perro',
    desc: 'Por qué ladra, por qué destruye, por qué no para. El diagnóstico honesto antes de empezar a corregir.',
    color: 'border-green-500/30'
  }, {
    icon: <Calendar className="w-8 h-8 text-yellow-400" data-id="element-321" />,
    title: 'TOMO 2 — El Protocolo de 21 Días',
    desc: 'Micro-Ausencias, Espacio Seguro Autónomo y Salida Invisible. El método paso a paso para que tu perro aprenda a estar solo sin ansiedad.',
    color: 'border-yellow-500/30'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-orange-400" data-id="element-322" />,
    title: 'TOMO 3 — Consolidación y Casos Especiales',
    desc: 'Retrocesos, mudanzas, bebés, nueva pareja, segunda mascota. Cómo sostener los logros para siempre.',
    color: 'border-orange-500/30'
  }, {
    icon: <HeartPulse className="w-8 h-8 text-red-400" data-id="element-323" />,
    title: 'TOMO 4 — Salud, Nutrición y Bienestar',
    desc: 'El perro sano es el perro tranquilo. Qué comer, cuánto moverse, cómo estimular.',
    color: 'border-red-500/30'
  }, {
    icon: <Users className="w-8 h-8 text-purple-400" data-id="element-324" />,
    title: 'TOMO 5 — Socialización y Vínculo',
    desc: 'Tu perro en el mundo: otros perros, la ciudad, el veterinario. Comunicación sin castigo.',
    color: 'border-purple-500/30'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-gold-400" data-id="element-325" />,
    title: 'TOMO 6 — Casos Reales y Situaciones Extremas',
    desc: 'El perro que no come solo. El que entró en pánico en Año Nuevo. Protocolos para los casos más difíciles.',
    color: 'border-gold-500/30'
  }];
  const includes = ['Protocolo día por día listo para aplicar', 'Sistema "Abrí y Empezá" (leés 5 min antes de la sesión)', 'Checklists diarios imprimibles', 'Plantillas de seguimiento y progreso', 'Variantes para casos más simples y más difíciles', 'Ejercicios adaptados a departamento y ciudad', 'Material original MUNDORECURSOS™', 'Adaptado a la realidad argentina'];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-326">
      <div className="text-center mb-16" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-328">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-329">
            🏆 Sistema N°1 para Dueños de Perros en Departamento
          </h2>
          <p className="text-xl md:text-2xl text-gold-400 font-medium mb-6" data-id="element-330">
            🐾 MUNDORECURSOS™ GUÍA DEL PERRO TRANQUILO™
          </p>
          <p className="text-lg text-blue-100 max-w-3xl mx-auto mb-6 font-medium" data-id="element-331">
            6 Tomos + 6 Bonos — Todos los perros — Todo resuelto.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm text-blue-200/80 mb-8" data-id="element-332">
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-333">
              +300 páginas
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-334">
              21 días modelo
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-335">
              Ansiedad
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-336">
              Ladridos
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-337">
              Destructividad
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-338">
              Rutina
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-339">
              Vínculo
            </span>
            <span className="px-3 py-1 bg-navy-800 rounded-full border border-navy-700" data-id="element-340">
              Socialización
            </span>
          </div>
          <p className="text-xl text-white font-bold mb-6" data-id="element-341">
            Funciona desde hoy.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-gold-400 font-medium" data-id="element-342">
            <span data-id="element-343">Cachorro</span> • <span data-id="element-344">Adulto</span> • <span data-id="element-345">Rescatado</span>{' '}
            • <span data-id="element-346">Ansioso</span> • <span data-id="element-347">Reactivo</span> •{' '}
            <span data-id="element-348">Departamento</span> • <span data-id="element-349">Ciudad</span>
          </div>
        </motion.div>
      </div>

      <div className="mb-12 text-center" data-id="element-350">
        <h3 className="text-2xl font-bold text-white mb-8 border-b border-navy-700 pb-4 inline-block" data-id="element-351">
          🎾 LOS 6 TOMOS
        </h3>
        <p className="text-blue-200" data-id="element-352">
          Para dueños de perros de todos los perfiles
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-16" data-id="element-353">
        {tomos.map((tomo, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className={`bg-navy-800/60 border ${tomo.color} p-8 rounded-2xl hover:bg-navy-800 transition-colors group`} data-id="element-354">
            <div className="mb-4 p-3 bg-navy-900 rounded-xl inline-block group-hover:scale-110 transition-transform" data-id="element-355">
              {tomo.icon}
            </div>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-356">{tomo.title}</h4>
            <p className="text-blue-100/80 leading-relaxed" data-id="element-357">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-358">
        <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-359">
          Cada tomo incluye:
        </h4>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-360">
          {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-361">
              <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0" data-id="element-362" />
              <span className="text-blue-50" data-id="element-363">{item}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}